export default "__VITE_ASSET__184c7ea9__"